export const APP_FAVICON =
  'data:image/png;base64,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'

export const EVENT_CLIPS_TAG_MODE = {
  NEXT_TO_TAG: 'NextToTag',
  RECENT_EVENTS: 'RecentlyTagged',
  GAME_EVENTS: 'GameEvents',
}

export const ACTION_TYPE = {
  BAD: 'Bad',
  ENABLE: 'Enable',
  GET_OCR_EVENT: 'GetOcrEvent',
  RETURN_OCR_EVENT: 'ReturnOcrEvent',
  DISABLE: 'Disable',
  ADD_EVENT: 'AddEvent',
  ADD_REPLAY: 'AddReplay',
  CHAIN: 'Chain',
  WARM_UP: 'WarmUp',
  REFRESH: 'Refresh',
  APPROVE: 'Approve',
  SAVE: 'Save',
  SYNC: 'Sync',
  GET_EVENTS: 'EventClips',
  GET_GAMES: 'GameVideos',
  GET_STREAMS: 'GameStreams',
  SET_STATUS: 'GameStatus',
  CONFLICT: 'Conflict',
  BAD_BULK: 'BadInABulk',
  DUPLICATE_EVENT: 'DuplicateEvent',
  UNLINK_ALL: 'UnlinkAll',
  GET_ACTIONS: 'GetActions',
}

export const APPROVE_STATUS = {
  BEFORE_APPROVAL: 'Before Approval',
  APPROVED: 'Approved',
}

export const EVENT_STATUS = {
  BAD: 'Bad',
  ENABLED: 'Enabled',
  NOT_TAGGED: 'Not Tagged',
  LINKED_REPLAYS: 'Events with linked replalys',
  NOT_LINKED_REPLAYS: 'Events without linked replays',
  APPROVED: APPROVE_STATUS.APPROVED,
  BEFORE_APPROVAL: APPROVE_STATUS.BEFORE_APPROVAL,
}

export const EVENT_STATUS_DISPLAY = {
  [EVENT_STATUS.BAD]: EVENT_STATUS.BAD,
  [EVENT_STATUS.ENABLED]: EVENT_STATUS.ENABLED,
  [EVENT_STATUS.NOT_TAGGED]: EVENT_STATUS.NOT_TAGGED,
  [EVENT_STATUS.LINKED_REPLAYS]: EVENT_STATUS.LINKED_REPLAYS,
  [EVENT_STATUS.NOT_LINKED_REPLAYS]: EVENT_STATUS.NOT_LINKED_REPLAYS,
  [APPROVE_STATUS.APPROVED]: APPROVE_STATUS.APPROVED,
  [APPROVE_STATUS.BEFORE_APPROVAL]: APPROVE_STATUS.BEFORE_APPROVAL,
}

export const GAME_STATUS = {
  NOT_STARTED: 0,
  RUNNING: 1,
  ENDED: 2,
}

export const GAME_STATUS_SMR = {
  NOT_STARTED: 'NotStarted',
  RUNNING: 'Running',
  ENDED: 'Ended',
  SUSSPENDED: 'Susspended',
}

export const GAME_STATUS_DISPLAY = {
  [GAME_STATUS.NOT_STARTED]: 'Not Started',
  [GAME_STATUS.RUNNING]: 'Running',
  [GAME_STATUS.ENDED]: 'Ended',
  [GAME_STATUS_SMR.NOT_STARTED]: 'Not Started',
  [GAME_STATUS_SMR.RUNNING]: 'Running',
  [GAME_STATUS_SMR.ENDED]: 'Ended',
  [GAME_STATUS_SMR.SUSSPENDED]: 'On hold',
}

export const ROLES = {
  CHECKER: 'Checker',
  SHIFT_MANAGER: 'ShiftManager',
  ADMIN: 'AdminOps',
  QC: 'QC',
  CROPPER: 'Cropper',
}

export const ROLES_IDS = {
  CHECKER: 9,
  SHIFT_MANAGER: 10,
  ADMIN_OPS: 11,
}

export const ROLES_IDS_YT = {
  CHECKER: 6,
  SHIFT_MANAGER: 7,
  ADMIN_OPS: 8,
}

export const CONTENT_TYPE_IDS = {
  GAMES: 1,
  PROGRAMS: 3,
}

export const CONTENT_TYPE_NAMES = {
  GAMES: 'Games',
  PROGRAMS: 'Programs',
}

export const GAME_VIDEO_TYPE_IDS = {
  GAMES: 1,
  PRESS: 2,
  STUDIO: 3,
}

export const GAME_VIDEO_TYPE_NAMES = {
  GAMES: 'Games',
  PRESS: 'Press Conference',
  STUDIO: 'Studio Show',
}

export const PROGRAM_SUBTYPE_IDS = {
  NONE: 0,
  PRESS: 1,
  STUDIO: 2,
}

export const ACTION_LINK_TYPE = {
  NONE: 0,
  REPLAY: 1,
  REACTION: 2,
  Topic: 3,
  Chapter: 4,
  PressConference: 5,
  Interview: 6,
}

export const LINK_ACTION_TYPES = [
  ACTION_LINK_TYPE.REACTION,
  ACTION_LINK_TYPE.Topic,
  ACTION_LINK_TYPE.Chapter,
  ACTION_LINK_TYPE.PressConference,
  ACTION_LINK_TYPE.Interview,
]

export const ACTION_LINK_NAME = {
  [ACTION_LINK_TYPE.REPLAY]: 'Replay',
  [ACTION_LINK_TYPE.REACTION]: 'Reaction',
}

export const LINK_TYPE = {
  Replay: 'Replay',
  Action: 'Action',
}
export const getDefaultLinkingEventclipIds = () => {
  return {
    [LINK_TYPE.Replay]: [],
    [LINK_TYPE.Action]: [],
  }
}

export const GAME_VIDEO_TYPE_OPTIONS = [
  { value: GAME_VIDEO_TYPE_IDS.GAMES, label: GAME_VIDEO_TYPE_NAMES.GAMES },
  { value: GAME_VIDEO_TYPE_IDS.PRESS, label: GAME_VIDEO_TYPE_NAMES.PRESS },
  { value: GAME_VIDEO_TYPE_IDS.STUDIO, label: GAME_VIDEO_TYPE_NAMES.STUDIO },
]

export const ROLE_NAMES = {
  [ROLES.CHECKER]: 'Checker',
  [ROLES.SHIFT_MANAGER]: 'Shift Manager',
  [ROLES.ADMIN]: 'Admin Ops',
  [ROLES.QC]: 'QC',
  [ROLES.CROPPER]: 'Cropper',
}

export const ROLES_NAMES_YT_PREFIX = 'YT'

export const ROLE_PERMISSIONS = {
  [ROLES.CROPPER]: 'cropperPermissions',
  [ROLES.QC]: 'taggerPermissions',
  [ROLES.CHECKER]: 'checkerPermissions',
  [ROLES.SHIFT_MANAGER]: 'shiftManagerPermissions',
  [ROLES.ADMIN]: 'adminOpsPermissions',
}

export const PERMISSIONS = {
  SHOW_APPROVE_BTN: 'showApproveBtn',
  SHOW_COMMENT_CREATOR: 'showCommentCreator',
  SHOW_COMMENTS: 'showComments',
  MAMBA_KEYBOARD_CONTROL: 'taggerKeyboardControl',
  SHOW_SYNC_BTN: 'newTaggerSync',
  MAMBA_ROLES: 'taggerRoles',
  MAMBA_IS_VIDEO_ANALYZER_BUTTON_VISIBLE: 'mambaIsVideoAnalyzerButtonVisible',
}

export const ROLE_PERMISSIONS_REVERSE = {
  taggerPermissions: ROLES.QC,
  checkerPermissions: ROLES.CHECKER,
  shiftManagerPermissions: ROLES.SHIFT_MANAGER,
  adminOpsPermissions: ROLES.ADMIN,
  cropperPermissions: ROLES.CROPPER,
}

export const APP_LOGIN_FLAG = 'allowLoginTagger'
export const MANUAL_TAGGING_MODE = 'taggerManualTaggingMode'
export const MANUAL_TAGGING_ADD_EVENT = 'taggerManuallyAddEvents'
export const MANUAL_TAGGING_DUPLICATE_EVENT = 'taggerManuallyDuplicateEvents'

export const SETTINGS_FLAG_VALUES = {
  DISABLE: 'Disable',
  HIDE: 'Hide',
  SHOW: 'Show',
}

export const IssueCreatedByMamba = 0

export const KEYBOARD_KEYS = {
  PLAY_PAUSE: {
    KEY: 'p,space',
    NAME: 'Play / Pause main player',
  },
  TOGGLE_EDIT_MOD: {
    KEY: 'f',
    NAME: 'Toggle edit mode',
  },
  SET_START: {
    KEY: 'q',
    NAME: 'Set clip start',
  },
  SET_END: {
    KEY: 'e',
    NAME: 'Set clip end',
  },
  PLAY_END: {
    KEY: 'r',
    NAME: 'Play end',
  },
  PLAY_SEGMENT: {
    KEY: 'w',
    NAME: 'Play Segment',
  },
  SET_EXACT_JUMP: {
    KEY: 'u',
    NAME: 'Set jump time',
  },
  JUMP_TO_EXACT: {
    KEY: 'i',
    NAME: 'Jump to specified time',
  },
  SAVE: {
    KEY: 's',
    NAME: 'Save & Enable',
  },
  APPROVE: {
    KEY: 'a',
    NAME: 'Approve',
  },
  ADD_REPLAY: {
    KEY: 'm',
    NAME: 'Add replay',
  },
  CHAIN: {
    KEY: 'c',
    NAME: 'Chain event',
  },
  SKIP_5_FOR: {
    KEY: 't',
    NAME: 'Skip +5 seconds on main player',
  },
  SKIP_5_BACK: {
    KEY: 'y',
    NAME: 'Skip -5 seconds on main player',
  },
  SKIP_1_FOR: {
    KEY: 'g',
    NAME: 'Skip +1 second on main player',
  },
  SKIP_1_BACK: {
    KEY: 'h',
    NAME: 'Skip -1 second on main player',
  },
  ONE_FRAME_FORWARD: {
    KEY: 'b',
    NAME: 'One frame forward',
  },
  ONE_FRAME_BACKWARD: {
    KEY: 'v',
    NAME: 'One frame backward',
  },
  SKIP_X_FOR: {
    KEY: ',',
    NAME: 'Skip (+/- time) seconds forward on main player',
  },
  SKIP_X_BACK: {
    KEY: 'n',
    NAME: 'Skip (+/- time) seconds backwards on main player',
  },
  SLOW_DOWN_PLAYER: {
    KEY: 'k',
    NAME: 'Slow down player',
  },
  SPEED_UP_PLAYER: {
    KEY: 'l',
    NAME: 'Speed up player',
  },
  NEXT_EVENT: {
    KEY: 'x',
    NAME: 'Next event',
  },
  PREVIOUS_EVENT: {
    KEY: 'z',
    NAME: 'Previous event',
  },
  DUPLICATE_EVENT: {
    KEY: 'd',
    NAME: 'Duplicate event',
  },
  RATING_1: {
    KEY: '1',
    NAME: '★',
  },
  RATING_2: {
    KEY: '2',
    NAME: '★★',
  },
  RATING_3: {
    KEY: '3',
    NAME: '★★★',
  },
  RATING_4: {
    KEY: '4',
    NAME: '★★★★',
  },
  RATING_5: {
    KEY: '5',
    NAME: '★★★★★',
  },
}

export const MODAL_WRAPPER_STYLE = {
  content: {
    height: 'auto',
    width: 'auto',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    padding: 'unset',
    marginRight: '-50%',
    border: 'none',
    background: 'none',
    borderRadius: '0',
    transform: 'translate(-50%, -50%)',
  },
  overlay: {
    backgroundColor: 'rgb(0, 0, 0, 0.6)',
    zIndex: 100,
  },
}

export const KEY_CODES = {
  ARROW_UP: 'ArrowUp',
  ARROW_DOWN: 'ArrowDown',
  ARROW_LEFT: 'ArrowLeft',
  ARROW_RIGHT: 'ArrowRight',
  TAB: 'Tab',
}
// audit actions
export const MAMBA_ACTIONS = {
  EVENT_CLICK: 0,
  SAVE_AND_ENABLE: 1,
  SET_BAD: 2,
  APPROVE: 3,
  COMMENT: 4,
  LOGIN: 5,
  LOGOUT: 6,
  EVENT_FETCHED_BY_MT: 7,
  GET_REAL_EVENT: 8,
  RETURN_REAL_EVENT: 9,
  CLICK_EDIT_BUTTON: 21,
  CHANGE_RECENT_X_FILTER: 29,
  CHANGE_AS_FILTER: 30,
  SWITCH_TABS_IN_MAMBA: 31,
  ADD_REPLAY_TO_HIDDEN: 35,
  EVENT_REPLAYS_EXPANDED: 36,
  AUTO_LINKED_REPLAY_ACCEPTED: 37,
  AUTO_LINKED_REPLAY_REFUCED: 38,
  DISMISS_AUTO_LINKED_REPLAY: 39,
  ISSUES_CREATE: 40,
  ISSUES_ACKNOWLEDGE: 41,
  EDIT_PLAYERS: 42,
  CROPOTI_PULL_EVENT: 43,
  CROPOTI_START_CROP: 44,
  CROPOTI_SAVE_CROP: 45,
}

export const ISSUES_MODAL_TAB = {
  REPORT: 'Report',
  UPDATES: 'Updates',
}

export const ISSUES_CATEGORY_TYPE = {
  STREAM: 0,
  DATA: 1,
  AUTO_TAG: 2,
  MAMBA: 3,
}

export const ISSUES_TYPE_CONTEXT = {
  GENERAL: 0,
  GAME: 1,
  EVENT: 2,
}
export const defaultJerseyNumber = 0
export const JerseyNumberInputMaxLength = 3

export const REPLAY_TYPE = {
  SHORT: 'S',
  LONG: 'L',
  SLOW_MOTION: 'SM',
}

export const REPLAY_ACTION_NAME = 'Replay'
export const REPLAY_ATTRIBUTES_PARAMETER_SET_NAME = 'Replay Attributes'
export const LIVE_DIFF = 20
export const LEARNING_SYSTEMS = [53, 79, 21001] // learning mamba system ids
export const BACKOFFICE_GROUP_ID = 100696
export const YOUTUBE_BACKOFFICE_GROUP_ID = 100020
export const HTTP_ERRORS_LIMIT = 150
export const HTTP_REPORT_ERROR_LIMIT = 10
export const APP_PAGES = {
  ROOT: '/',
  MULTI: 'MultiMamba',
  GAME: 'GameMamba',
  CROPOTI: 'Cropoti',
  ATG_MAMBA: 'ATG Mamba',
}
export const POLLING_TIMEOUT_TIME = 1000
export const DEFAULT_STREAM_SYSTEM_ID = 8001
export const MAX_PRIORITIZED_EVENT_VALUE = 4

//Error status codes
export const ETAG_CONFLICT_ERROR_STATUS_CODE = 409
export const NOT_FOUND = 404
export const BAD_REQUEST = 400
export const SYNC_AUDIO_TYPES = {
  0: 'Same Audio',
  1: 'Different Audio',
}
export const AUTO_SAVE_TYPE = {
  0: 'None',
  1: 'All Events',
  2: '1-Star Events',
}

export const CONFIDENCE_TYPE = {
  HIGH: 'High Confidence',
  LOW: 'Low Confidence',
  NONE: 'None',
}

export const OFFSET_TAGGING_TYPE = {
  MASTER: 'Master',
  SLAVE: 'Slave',
  SINGLE: 'Single',
}

export const MAX_NUMBER_OF_SETS = 5

const OVERRIDEN_STATUS = {
  NO_OVERRIDE: 0,
  START_TIME: 1,
  END_TIME: 2,
  RATING: 4,
}

export const OVERRIDEN_STATUS_MESSAGE = {
  [OVERRIDEN_STATUS.NO_OVERRIDE]: '',
  [OVERRIDEN_STATUS.START_TIME]: 'Event start time edited',
  [OVERRIDEN_STATUS.END_TIME]: 'Event end time edited',
  [OVERRIDEN_STATUS.RATING]: 'Event rating edited',
  [OVERRIDEN_STATUS.START_TIME + OVERRIDEN_STATUS.END_TIME]: 'Event times edited',
  [OVERRIDEN_STATUS.START_TIME + OVERRIDEN_STATUS.END_TIME + OVERRIDEN_STATUS.RATING]:
    'Event times edited \n Event rating edited',
}

export const GAME_PROGRESS_PARAM_TYPE = {
  SELECT: 'SELECT',
  INTEGER: 'Integer',
}

export const EVENT_APPROVAL_STATUS = {
  BEFORE_APPROVAL: 0,
  APPROVED: 1,
}

export const FILTER_NAMES = {
  STATUS: 'statusFilter',
  TEAM: 'teamFilter',
  PLAYER: 'playerFilter',
  RATING: 'ratingFilter',
  ACTION: 'actionFilter',
  ACTION_TYPE: 'actionTypeFilter',
  PERIOD: 'periodFilter',
  GAME_VIDEO: 'gameVideoFilter',
  CONFIDENCE: 'confidenceFilter',
  REPLAY: 'replayFilter',
}

export const GAME_VIDEO_ID = 'gameVideoId'
export const GAME_VIDEOS_ITEMS_NUMBER = 5000

export const PAGE_GVIDS = {
  GAME: 'gameGvids',
  MULTI: 'multiGvids',
  ATG: 'atgGvids',
}

export const REPLAY_FILTER_VALUES = {
  HIDDEN: 0,
  BAD: 1,
  ALL: 2,
}

export const ACTION_TYPE_VALUES = {
  EXCLUDE_NON_GAME_PLAY: 0,
  ONLY_NON_GAME_PLAY: 1,
}

export const ACTION_TYPE_NAMES = {
  EXCLUDE_NON_GAME_PLAY: 'Exclude non-game play',
  ONLY_NON_GAME_PLAY: 'Only non-game play',
}

export const EVENT_CLIP_PARAM_ICONS = {
  EVENT_FROM_MASTER: 'master-event',
  EVENT_IS_MANUAL: 'manual-event',
}

export const EVENT_CLIP_CROPOTI_PARAM_ICONS = {
  EVENT_FROM_MASTER_SELECTED: 'master-event-cropoti-selected',
  EVENT_FROM_MASTER: 'master-event-cropoti',
  EVENT_CROP_DATA_EXIST: 'check-mark-black',
}

export const FEED_DIRECTION = {
  BACKWARD: 'backward',
  FORWARD: 'forward',
}

export const MANUAL_EVENT_DEFAULT_PARAMS = {
  scoreHome: 0,
  scoreVisitor: 0,
  quarter: '1',
  gameClock: '10:00',
}

export const EVENT_CLIP_RESET_TIME = -1
export const FEED_OFFSET_TOP_MARGIN = 200
export const FEED_CLASS_NAME = 'eventsClips'
export const HIGH_CONFIDENCE_LIMIT = 2

export const BRICK_DATA_TYPE = {
  None: 0,
  Boolean: 1,
  Int: 2,
  NullableInt: 3,
  Decimal: 4,
  NullableDecimal: 5,
  Text: 6,
  Dictionary: 7,
  Enum: 8,
  GameClock: 9,
  ShowJumpingResult: 10,
  ShowJumpingResultList: 11,
  NullableTimeSpan: 12,
}

export const BRICK_BOOLEAN_OPTIONS = ['No', 'Yes']

export const ROUTE_NAME = {
  GAME: 'game-mamba',
  MULTI: 'multi-mamba',
  CROPOTI: 'cropoti',
  ATG_MAMBA: 'atg',
}

export const EVENT_ADDITIONL_PLAYERS_ACTIONS = {
  ADDITIONAL: 'AdditionalSpeaker',
  MENTIONED: 'Mention',
}

export enum GameProgressParamName {
  GameClock = 'GameClock',
  GamePhase = 'GamePhase',
  Overtime = 'Overtime',
  Quarter = 'Quarter',
}

export enum GamePhase {
  Unknown = 'Unknown',
  PreGame = 'PreGame',
  InGame = 'InGame',
  GameBreak = 'GameBreak',
  PostGame = 'PostGame',
}

export const CONFIRM_MODAL_LABELS = {
  YES: 'YES',
  NO: 'NO',
}

export const MAMBA_VIDEO_MIN_START_TIME = 0
export const MAMBA_VIDEO_OFFSET = 9
export const MAMBA_VIDEO_DEFAULT_RATING = 2
export const DEFAULT_INPUT_MIN_NUMBER = -999
export const DEFAULT_INPUT_MAX_NUMBER = 999
export const ATG_GET_INTERVAL = 20000

export enum GAME_PROGRESS_PARAMS_ROUTE {
  Properties = 'GameProgressProperties',
  Parameters = 'GameProgressParameters',
}

export const UseOneClickGameProgressLogicSettingName = 'useOneClickGameProgressLogic'
export const UseOneClickScoreLogicSettingName = 'useOneClickScoreLogic'
export const SETTINGS_FOR_SYSTEM_NAMES = [
  UseOneClickGameProgressLogicSettingName,
  UseOneClickScoreLogicSettingName,
]
export const MISSING_EVENT_NAME_TEXT = 'Missing Event Name'
export const EMPTY_TEXT = ''

export enum UrlParams {
  IsAccessedFromDiesel = 'isAccessedFromDiesel',
}

export enum IframeEvent {
  MambaLoaded = 'MambaLoaded',
  MiniMambaEventSaved = 'MiniMambaEventSaved',
}
